import React from 'react';

import { Box, Skeleton } from '@mui/material';

import type { Nullable } from '@clearverify/types';

import { useStripeCustomerPaymentMethods } from 'src/hooks/stripe';

import { StripePaymentMethodItem } from './StripePaymentMethodItem/StripePaymentMethodItem';

interface StripeCustomerPaymentMethodsListProps {
  stripeCustomerId: Nullable<string>;
}

export const StripeCustomerPaymentMethodsList: React.FC<StripeCustomerPaymentMethodsListProps> = ({
  stripeCustomerId,
}) => {
  const {
    paymentMethods,
    defaultPaymentMethodId,
    loadingPaymentMethods,
    detachingPaymentMethod,
    detachPaymentMethod,
    updateDefaultPaymentMethod,
  } = useStripeCustomerPaymentMethods(stripeCustomerId);

  const loading = loadingPaymentMethods || detachingPaymentMethod;

  return loading ? (
    <Skeleton height={86} />
  ) : (
    <Box display="flex" flexDirection="column" mt={2} rowGap={2}>
      {paymentMethods.map(paymentMethod => (
        <StripePaymentMethodItem
          key={`payment-method-${paymentMethod.id}`}
          paymentMethod={paymentMethod}
          isDefault={defaultPaymentMethodId === paymentMethod.id}
          onDetach={() => detachPaymentMethod(paymentMethod.id)}
          onSetDefault={() => updateDefaultPaymentMethod(paymentMethod.id)}
        />
      ))}
    </Box>
  );
};
